import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]

import { Ban, WifiOff } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorGatedKpiCell',
  props: {
    hasSensor: { type: Boolean },
    hasValue: { type: Boolean },
    openTitle: {},
    buttonClass: {}
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (!_ctx.hasSensor)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "block px-3 py-[9px]",
        title: _ctx.$t('views.monitoring.activeGroups.texts.noSensor')
      }, [
        _createVNode(_unref(Ban), {
          class: "h-3.5 w-3.5 text-gray-300",
          "aria-hidden": "true"
        })
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: _normalizeClass(["w-full rounded-md px-3 py-[9px] transition-colors hover:bg-gray-200", _ctx.buttonClass]),
        title: _ctx.openTitle,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open')))
      }, [
        (_ctx.hasValue)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 })
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              title: _ctx.$t('views.monitoring.activeGroups.texts.noData')
            }, [
              _createVNode(_unref(WifiOff), {
                class: "h-3.5 w-3.5 shrink-0 text-gray-300",
                "aria-hidden": "true"
              })
            ], 8, _hoisted_3))
      ], 10, _hoisted_2))
}
}

})